import { ref } from 'vue'
import { defineStore } from 'pinia'
import { generalStore } from './index.js';
import { useTranslation } from 'i18next-vue';

export const shoppingCart = defineStore('cartStore', () => {
  const store = generalStore();
  var shoppingCart = ref(store.getSessionStorage('shoppingCart'));
  const { t } = useTranslation();

  /*SHOPPING CART */
  const newProduct = (product) => {
    shoppingCart.value = store.getSessionStorage('shoppingCart')
    if (product.cat == 'Camisas' || product.cat == 'Anillos' || product.cat == 'Cuadros') {
      if (product.size == null) {
        store.setAlertMsg(t('miss-size'));
        store.setAlertType('error');
        store.setAlertState();
        return 'error';
      } else {
        if (shoppingCart.value != null) {
          var index = shoppingCart.value.findIndex((productF) => ((productF.id === product.id) && (productF.color === product.color) && (productF.size === product.size)))
          if (index != -1) {
            if (shoppingCart.value[index]['qty'] < product.total) {
              shoppingCart.value[index]['qty'] += 1;
            } else {
              handlerErrAddProduct();
              return 'error';
            }
          } else {
            product.qty = 1;
            shoppingCart.value.push(product)
          }
        } else {
          product.qty = 1;
          shoppingCart.value = [product]
        }
      }
    } else {
      if (shoppingCart.value != null) {
        var index = shoppingCart.value.findIndex((productF) => ((productF.id === product.id) && (productF.color === product.color)))
        if (index != -1) {
          if (shoppingCart.value[index]['qty'] < product.total) {
            shoppingCart.value[index]['qty'] += 1;
          } else {
            handlerErrAddProduct();
            return 'error';
          }
        } else {
          product.qty = 1;
          shoppingCart.value.push(product)
        }
      } else {
        product.qty = 1;
        shoppingCart.value = [product]
      }
    }
    store.setSessionStorage('shoppingCart', shoppingCart.value);
    store.setAlertMsg(t('new-product'));
    store.setAlertType('success');
    store.setAlertState();
    return 'ok';
  }

  const getShoppingCart = () => {
    return shoppingCart.value
  }

  /**
   * Function used to update the qty of the product in the array to the shopping cart
   * @param {*} value Data to update (Json array)
   */
  const updateQty = (value) => {
    shoppingCart.value[value['index']]['qty'] = value['qty'];
    store.setSessionStorage('shoppingCart', shoppingCart.value);
  }

  /**
   * Function used to delete a product in the array to the shopping cart
   * @param {*} index Position of the product in the array
   */
  const delProduct = (index) => {
    (shoppingCart.value).splice(index, 1);
    if (shoppingCart.value.length >= 1) {
      store.setSessionStorage('shoppingCart', shoppingCart.value);
      handlerDelProduct();
    } else {
      store.removeSessionStorage('shoppingCart');
      deleteShoppingCart();
      handlerDelShoppingCart();
    }
  }

  /**
   * Function used redest shopping cart
   */
  const deleteShoppingCart = () => {
    shoppingCart.value = null
  }

  /*CALCULATE*/
  /**
   * Function used to calculate the subtotal of the product
   * @param {*} value Data to calculate (Json array)
   * @returns Calculated subtotal
   */
  const calculateSubTotal = (value) => {
    return value['qty'] * value['price'].replace('$', '')
  }

  /**
   * Function used to calculate the total of the shopping cart products
   * @returns Calculated total
   */
  const calculateTotal = () => {
    var total = 0
    shoppingCart.value.forEach(product => {
      total += (product['price'].replace('$', '') * product['qty'])
    });

    return total;
  }

  const handlerErrAddProduct = () => {
    store.setAlertMsg(t('error-addProduct'))
    store.setAlertType('error');
    store.setAlertState();
  }

  const handlerErrShoppingCart = () => {
    store.setAlertMsg(t('error-shoppingCart'))
    store.setAlertType('error');
    store.setAlertState();
  }

  const handlerDelProduct = () => {
    store.setAlertMsg(t('del-product'))
    store.setAlertType('information');
    store.setAlertState();
  }

  const handlerVoidShoppingCart = () => {
    store.setAlertMsg(t('void-shoppingCart'))
    store.setAlertType('information');
    store.setAlertState();
  }

  const handlerDelShoppingCart = () => {
    store.removeSessionStorage('shoppingCart')
    store.setAlertMsg(t('del-sc'));
    store.setAlertType('information');
    store.setAlertState();
  }

  const handlerSuccessShoppingCart = () => {
    store.removeSessionStorage('shoppingCart')
    store.setAlertMsg(t('success-order'));
    store.setAlertType('success');
    store.setAlertState();
  }

  return {
    getShoppingCart,
    delProduct,
    deleteShoppingCart,
    newProduct,
    updateQty,
    calculateSubTotal,
    calculateTotal,
    handlerErrShoppingCart,
    handlerDelProduct,
    handlerVoidShoppingCart,
    handlerDelShoppingCart,
    handlerSuccessShoppingCart
  }
})